import { FC, useRef, useState } from "react";

import { observer } from "mobx-react";

import Chat from "assets/icons/44x44/chat.svg";
import ChatBlack from "assets/icons/44x44/chat-black.svg";

import { useStore } from "store";
import { cn } from "helpers/style";

import HelpModal from "./components/HelpModal/HelpModal";

import styles from "./HelpModalIcon.module.scss";

type Props = {
  classNameChat?: string;
};

const HelpModalIcon: FC<Props> = ({ classNameChat }) => {
  const [isModal, setIsModal] = useState(false);
  const { notifications } = useStore();
  const helpModalDisposeRef = useRef(null);

  const handleHelp = () => {
    if (isModal) {
      helpModalDisposeRef.current();
      setIsModal(false);
      return;
    }

    setIsModal(true);
    helpModalDisposeRef.current = notifications.show({
      type: "modal",
      component: HelpModal,
      props: {
        setIsModal,
      },
    });
  };

  return (
    <div
      className={cn([isModal && styles.helpActive, classNameChat])}
      onClick={handleHelp}
    >
      {isModal ? <ChatBlack /> : <Chat />}
      <span>Помощь</span>
    </div>
  );
};

export default observer(HelpModalIcon);
